<template>
    <!-- 车辆进行报价 -->
    <div class="wrapper">
        <!-- 查询区域 -->
        <div v-show="showSearch">
            <el-form :inline="true">
                <el-row>
                   <el-form-item label="查询时间范围">
                       <el-date-picker
                           v-model="queryPara.bidDateRange"
                           type="daterange"
                           value-format="yyyy-MM-dd"
                           range-separator="-"
                          
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                       </el-date-picker>
   
                   </el-form-item>
   
                   <el-form-item label="登记时间范围">
                   <el-date-picker
                       v-model="queryPara.regDateRange"
                       type="daterange"
                       value-format="yyyy-MM-dd"
                           range-separator="-"
                       start-placeholder="开始日期"
                       end-placeholder="结束日期">
                   </el-date-picker>
                  
                   </el-form-item>
   
                   
                </el-row>
                
                <el-row>
                    <el-form-item label="报案号">
                        <el-input v-model="queryPara.caseSn" placeholder="请输入报案号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="车辆编号">
                        <el-input v-model="queryPara.vehicleSn" placeholder="请输入车辆编号" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="车牌号">
                        <el-input v-model="queryPara.current.plateNo" placeholder="请输入车牌号" clearable></el-input>
                    </el-form-item>
    
                   
    
                    <el-form-item label="车架号">
                        <el-input v-model="queryPara.factory.vin" placeholder="请输入车架号"></el-input>
                    </el-form-item>
                </el-row>
    
                <el-row>
                    
                    <el-form-item label="车辆型号:">

                        <el-autocomplete
                            v-model="queryPara.factory.vehicleTradeName"
                            :fetch-suggestions="querySearchModelName"
                            value-key="modelName"
                            placeholder="请输入车辆型号"
                            clearable
                            ></el-autocomplete>
                    </el-form-item>
                
                    <el-form-item label="保险公司">
                        <el-input v-model="queryPara.insurance.insuranceCompany" placeholder="请输入保险公司"></el-input>
                    </el-form-item>
    
    
                    <el-form-item label="区域">
                       
                        <el-select v-model="queryPara.check.district" placeholder="请选择区域" clearable>
                            <el-option
                                v-for="dict in dict.type.vehicle_district"
                                :key="dict.value"
                                :label="dict.label"
                                :value="dict.value"
                                />
                        </el-select>
                    </el-form-item>
    
                  
                    <el-form-item  label="中签状态">
                        <el-select v-model="queryPara.winStatus" placeholder="请选择中签状态" clearable>
                                <el-option 
                                    v-for="dict in dict.type.sys_yes_no"
                                    :key="dict.value"
                                    :label="dict.label"
                                    :value="dict.value"
                                />
                        </el-select>
                    </el-form-item>
                </el-row>

                <el-form-item>
                    <el-button size="mini" type="primary" icon="el-icon-refresh" @click="handleQuery">查询</el-button>
                    <el-button size="mini" icon="el-icon-refresh"   @click="handleReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- 按钮操作区域 -->
        <el-row :gutter="10" class="mb8">
         
          <el-col :span="1.5">
            <el-button
              type="info"
              plain
              icon="el-icon-sort"
              size="mini"
              @click="toggleExpandAll"
            >展开/折叠</el-button>
          </el-col>
          <right-toolbar :showSearch.sync="showSearch" @queryTable="getListData"></right-toolbar>
        </el-row>
        
        <!-- 1 table区域 -->
        <el-table :data="listData" 
        v-if="refreshTable"
        :default-expand-all="isExpandAll"
        v-loading="loading" element-loading-text="正在查询中...">
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="逾期时间" prop="bidEndTime">
                <!--
                <template v-slot="slotProps">
                    {{parseTime(slotProps.row.bidEndTime,'{y}-{m}-{d}')}}
                </template>
                -->
            </el-table-column>
            <!--
            <el-table-column label="询价时间" prop="bidStartTime">
              
            </el-table-column>
            -->
            <el-table-column label="保险公司" prop="insurance.insureCompany">
            </el-table-column>
    
            <el-table-column label="车牌照号" prop="current.plateNo">
    
            </el-table-column>
    
            <el-table-column label="登记日期" prop="factory.registerDate">
                <template v-slot="slotProps">
                    {{parseTime(slotProps.row.factory.registerDate,'{y}-{m}-{d}')}}
                </template>
            </el-table-column>

            <el-table-column label="车辆型号" prop="factory.vehicleModel"></el-table-column>
            <el-table-column label="区域" prop="check.district">
                <template slot-scope="scope">
                    <dict-tag :options="dict.type.vehicle_district" :value="scope.row.check.district"/>
                </template>
            </el-table-column>
            <el-table-column label="是否中签" prop="quote.winStatusIn">

                <template slot-scope="scope"> 
                    <el-tag  effect="dark" v-if="scope.row.quote.winStatusIn=='Y'" type="success">已中签</el-tag>
                    <el-tag  effect="dark" v-if="scope.row.quote.winStatusIn=='U'" type="warning">未知</el-tag>
                    <el-tag  effect="dark" v-if="scope.row.quote.winStatusIn=='N'" type="danger">未中签</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="投标金额" prop="bidChoose.bidSubmitPrice">

            </el-table-column>
            <el-table-column label="中标公司" prop="bidCompany">

            </el-table-column>

            <el-table-column label="中标价格" prop="bidPrice">

            </el-table-column>
            
            <el-table-column label="我的报价" prop="quote.finalPrice"></el-table-column>
    
            <el-table-column label="操作" width="240" fixed="right">
                <template v-slot="slotProps">
                    <el-button @click="showDetailView(slotProps.row)"  size="small" >详情</el-button>
                    <el-button v-if="showUpdateQuoteButton(slotProps.row.caseStatus)" size="small" type="primary" @click="handleQuote(slotProps.row)">修改报价</el-button>
                </template>
                
            </el-table-column>
    
        </el-table>
        
        <!-- 分页区域 -->
        <pagination  v-show="totalRow>0" :total="totalRow" :page.sync="page.pageNumber" 
            :limit.sync="page.pageLimit" 
            @pagination="getListData">
        </pagination>
    </div>
    
    </template>
    <script>
    import Const from '@/utils/constant'
    import {haveQuoteListCase} from '@/api/vehicle/case'
    import {getVehileModelList} from '@/api/vehicleConfig/vehicleModel'

    import Pagination from '@/components/Pagination'
    export default {
        name:'Have-quote-list',
    components:{Pagination},
    dicts:['sys_yes_no','vehicle_district'],
    data(){
        return{
            constData:Const,
            // 是否展开，默认全部展开
            isExpandAll: true,
            refreshTable:true,
            showSearch:true,//显示搜索
            loading : false,
            queryPara:{
                bidDateRange:[],
                regDateRange:[],
                winStatus:'',
                vehicleSn:'',//车辆编号
                current:{
                    plateNo:'',
                },
                factory:{
                    vin:'',
                },
                insurance:{
                    insuranceCompany:'',
                },
                check:{
                    district:'',
                }
                
            },
            listData:[],
            
            totalRow: 0,
            page: {
                pageNumber: 1,
                pageLimit: 10,
            },
        }
    },
    created(){
        this.handleQuery();
    },
    methods:{
        toggleExpandAll() {
                this.refreshTable = false;
                this.isExpandAll = !this.isExpandAll;
                this.$nextTick(() => {
                    this.refreshTable = true;
                });
        },
        handleReset(){
            
            this.queryPara={
                //保险公司部门
                caseSn:'',//报案号
                bidDateRange:[],//竞价时间范围
                regDateRange:[],
                vehicleSn:'',//车辆编号
                bidCompany:'', //中标公司
                // 保险公司信息
                insurance:{
                    insureCompany:'',//保险公司
                    insureFiliale:'',//保险分公司
                },
                
                //车辆信息
                
                current:{
                    plateNo:'',//车牌号
                },
               
                factory:{
                    vin:'',//车架号
                    vehicleTradeName:'',
                },
                regDateRange:[],//车辆登记日期
                queryPara:'',
              
                clientContact:'',
                check:{
                    isCheck:'',
                    vehicleLevel:'',
                    district:'',
                },
                caseStatus:'',//案件状态
                orderSort:'ascending',
                columnName:'',
            };
        },
    
        //查询
        handleQuery(){
            this.page.pageNumber=1;
            this.getListData();
        },
    
        /**
         * 获取列表数据
         */
        getListData(){
            var para=Object.assign({},{page:this.page})
            this.loading = true;
            var para=Object.assign(this.queryPara,this.page)
            para=this.addDateRange(para,this.queryPara.bidDateRange,"bid")
            para=this.addDateRange(para,this.queryPara.regDateRange,"reg")
            
            haveQuoteListCase(para).then(res=>{
                this.loading = false;
                this.totalRow=res.data.totalRow;
                this.listData=res.data.list;
            })
        },

        //进行报价
        handleQuote(para){
            this.$router.push({ path: '/vehicle-quote/edit',query:{caseid: para.caseId}});
        },
        /**
        * 显示详情界面
        * @param {*} para 
        */
        showDetailView(para){
            this.$router.push({ path: '/vehicle-quote/detail',query:{caseid: para.caseId,date:new Date().getTime()}});
        },

        //显示修改报价
        showUpdateQuoteButton(status){
            if(status===this.constData.CASE_STATUS_QUOTATION){
                return true;
            }else{
                return false;
            }
        },

         /**
         * 搜索车辆型号的名字
         */
        querySearchModelName(queryString, callback){
            var para={"modelName":queryString};
            getVehileModelList(para).then(res=>{
                callback(res.data);
            })
        },
        
    }
    }
    </script>
    <style scoped>
        .wrapper{
            margin-left: 5%;
            margin-right: 5%;
        }
       
    </style>